import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  startRegistration,
  browserSupportsWebAuthn,
} from '@simplewebauthn/browser';
import { PasskeysService } from '../../services/passkeys/passkeys.service';
import { TranslateService } from '../../services/translate/translate.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { IUser } from '../../interfaces/toolbar/toolbar.interface';

interface Devices {
  id: string;
  name: string;
  disable: boolean;
}

interface TranslateModalPasskeys {
  title: string;
  text: string;
  buttonNew: string;
  buttonClose: string;
  messageConfirmDeletePasskey: string;
  messageNotPasskey: string;
  titleMessageAddPasskey: string;
  textMessageAddPasskey: string;
  titleMessageUpdate: string;
  textMessageUpdate: string;
  titleMessageDelete: string;
  textMessageDelete: string;
  optionDelete: string;
}

@Component({
  selector: 'mg-modal-passkeys',
  templateUrl: './modal-passkeys.component.html',
  styleUrls: ['./modal-passkeys.component.scss'],
})
export class ModalPasskeysComponent implements OnInit, OnDestroy {
  messageNotSoportPasskeys = '';
  nameEditDevice: string = '';
  devices: Devices[] = [];
  textTranslate!: TranslateModalPasskeys;
  subscriptionTranslate!: Subscription;
  loading: boolean = true;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { data: IUser; url: string },
    public dialogRef: MatDialogRef<ModalPasskeysComponent>,
    private passkeysService: PasskeysService,
    private translate: TranslateService,
    private toastAlert: ToastrService
  ) {}

  ngOnInit(): void {
    this.dataTranslate();
    this.getPasskeys();
  }

  validateUsePasskeys(): boolean {
    return browserSupportsWebAuthn();
  }

  getPasskeys() {
    this.passkeysService
      .getCredentials(this.data.url, this.data?.data)
      .subscribe(
        (resp: any) => {
          if (resp.data.credentials?.allowCredentials) {
            this.devices =
              resp.data.credentials.allowCredentials.map((credential: any) => {
                return {
                  id: credential.id,
                  name: credential.userInformation.displayName,
                  disable: true,
                };
              }) || [];
          }
          this.loading = false;
        },
        (error) => {
          this.toastAlert.error(
            error.error.errorMessage || error.message,
            'Error'
          );
          this.loading = false;
        }
      );
  }
  addPassKey() {
    this.cancelEdit();
    this.passkeysService
      .createRegistration(this.data.url, this.data.data)
      .subscribe((resp: any) => {
        let options = { ...resp.data };
        const challenge = options.challenge;
        const userInfo = options.user;

        startRegistration(options).then((resp) => {
          this.loading = true;
          this.passkeysService
            .verifyRegistration(
              this.data.url,
              this.data.data,
              userInfo,
              challenge,
              resp
            )
            .subscribe(
              (resp: any) => {
                this.devices.push({
                  name: resp.data.device.userInformation.displayName,
                  id: resp.data.device.userInformation.id,
                  disable: true,
                });
                this.toastAlert.success(
                  this.textTranslate.textMessageAddPasskey,
                  this.textTranslate.titleMessageAddPasskey
                );
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                this.toastAlert.error(
                  error.error.errorMessage || error.message,
                  'Error'
                );
              }
            );
        });
      });
  }

  dataTranslate() {
    this.subscriptionTranslate = this.translate
      .init('core')
      .subscribe((data) => {
        this.textTranslate = data.toolbar.modalPasskeys;
      });
  }

  activeEdit(device: Devices) {
    this.devices = this.devices.map((deviceItem) =>
      deviceItem.id === device.id
        ? { ...deviceItem, disable: false }
        : { ...deviceItem, disable: true }
    );
    this.nameEditDevice = device.name;
  }
  cancelEdit() {
    this.devices = this.devices.map((device) => ({ ...device, disable: true }));
  }
  saveEditDevice(device: Devices) {
    this.loading = true;
    this.passkeysService
      .editPasskey(
        this.data.url,
        this.data.data,
        this.nameEditDevice,
        device.id
      )
      .subscribe(
        () => {
          this.devices = this.devices.map((deviceItem) =>
            deviceItem.id === device.id
              ? { ...deviceItem, name: this.nameEditDevice, disable: true }
              : deviceItem
          );
          this.toastAlert.success(
            this.textTranslate.textMessageUpdate,
            this.textTranslate.titleMessageUpdate
          );
          this.nameEditDevice = '';
          this.loading = false;
        },
        (error) => {
          this.toastAlert.error(
            error.error.errorMessage || error.message,
            'Error'
          );
          this.loading = false;
        }
      );
  }
  deleteDevice(device: Devices) {
    this.loading = true;
    this.passkeysService
      .deletePasskey(this.data.url, this.data.data, device.id)
      .subscribe(
        (resp) => {
          this.devices = this.devices.filter(
            (deviceItem) => deviceItem.id !== device.id
          );
          this.loading = false;
          this.toastAlert.success(
            this.textTranslate.textMessageDelete,
            this.textTranslate.titleMessageDelete
          );
        },
        (error) => {
          this.toastAlert.error(
            error.error.errorMessage || error.message,
            'Error'
          );
          this.loading = false;
        }
      );
  }

  onInputDevice(event: any) {
    this.nameEditDevice = event.target.value;
  }
  ngOnDestroy(): void {
    this.subscriptionTranslate?.unsubscribe();
  }
}
